import styled from "styled-components";

export const Root = styled.div`
  padding-top: 105px;

  &.mobile {
    padding: 84px 0 0;

    h2 {
      font-size: 20px;
      line-height: 24px;
    }

    .sub {
      h2 {
        font-size: 22px;
        line-height: 26px;
      }
    }

    .desc {
      margin-top: 25px;
      line-height: 16px;
      font-size: 12px;
    }

    .sub-data {
      display: block;
      margin: 30px 12px 50px;

      li {
        height: auto;
        padding: 16px;
        margin: 0 0 15px 0!important;

        p {
          margin-bottom: 10px;
          font-size: 12px;
        }

        strong {
          line-height: 26px;
          font-size: 22px;
        }

        .icon {
          width: 30px;
          height: 30px;

          svg {
            transform: scale(0.6);
          }
        }
      }
    }

    .dapp {
      width: auto;
      flex-direction: column-reverse;
      margin-top: 15px;
      padding: 0 12px;

      .actions {
        a {
          width: 135px;
          margin-right: 20px;
          justify-content: center;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .info {
        width: 100%;
        margin: 32px 0 0;

        h1 {
          font-size: 28px;
          line-height: 32px;
        }

        .desc {
          margin: 28px 0 25px;
          font-size: 12px;
          line-height: 16px;
        }
      }

      .img {
        min-height: 0;
        
        img {
          width: 80%;
          margin: 0 auto;
        }
      }
    }

    .programs {
      .left {
        width: 100%;
      }

      .info {
        padding: 0;

        .desc {
          width: auto;
          margin-top: 20px;
        }
      }

      .img {
        img {
          width: 100%;
        }
      }
    }

    .functions {
      margin-top: 40px;

      ul {
        width: 100%;
        padding-left: 24px;
        box-sizing: border-box;

        .blank1, .blank2 {
          display: none;
        }
      }

      li {
        opacity: 1!important;
        transform: none!important;
        width: 50%;
        margin-right: 0!important;
        margin-bottom: 30px;
        padding: 0 24px 0 0;
        box-sizing: border-box;
        border-radius: 10px 10px 10px 10px;
        text-align: left;

        &:hover {
          box-shadow: none;
        }

        .img {
          transform: scale(0.75);
          justify-content: flex-start;
          padding-left: 15px;
        }

        .name {
          margin-top: 15px;
          font-weight: bold;
          font-size: 14px;
        }

        .desc {
          margin-top: 15px;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }

  h2 {
    font-size: 42px;
    line-height: 50px;
  }

  .desc {
    margin-top: 30px;
    line-height: 22px;
    color: #666666;
  }

  .dapp {
    display: flex;
    align-items: center;
    width: 1200px;
    margin-top: 100px;
    box-sizing: border-box;

    .info {
      margin-right: 40px;
      width: 510px;

      h1 {
        font-size: 48px;
      }

      .desc {
        margin: 56px 0 60px;
        font-size: 22px;
        line-height: 26px;
        color: #333;
      }
    }

    .img {
      flex-shrink: 0;

      img {
        display: block;
      }
    }
  }

  .sub-data {
    margin: 20px 0 50px;
    display: flex;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      height: 146px;
      padding: 0 30px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #EEEE;
      
      &:not(:last-child) {
        margin-right: 30px;
      }

      p {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
      }

      strong {
        line-height: 38px;
        font-weight: bold;
        font-size: 32px;
      }

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        background: #F7E8E5;
        border-radius: 10px 10px 10px 10px;
      }
    }
  }

  .dapp1 {
    justify-content: space-between;

    .img {
      min-height: 560px;
    }

    .actions { 
      a {
        width: 175px;
        justify-content: center;
        padding: 0;
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;

    a {
      margin-right: 30px;
      svg {
        margin-left: 5px;
      }
    }
  }

  .programs {
    width: 100%;
    margin-top: 30px;
    padding: 0;

    &.show {
      .info {
        .desc, .actions {
          opacity: 1;
          transform: none;
        }
      }
      .img {
        display: block;
        opacity: 1;
      }
    }

    .left {
      width: 50%;
      display: flex;
      flex-direction: row-reverse;
    }
    .info {
      width: 600px;
      margin: 0;
      padding-left: 100px;

      .desc {
        width: 495px;
        line-height: 24px;
        font-size: 18px;

        p {
          display: flex;
          &:not(:last-child) {
            margin-bottom: 30px;
          }

          i {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            margin-right: 10px;
            box-sizing: border-box;
            border: 2px solid #E9361B;
            border-radius: 50%;
            position: relative;
            top: 4px;

            &::after {
              content: '';
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #E9361B;
            }
          }
        }

        strong {
          color: #C13329;
          font-weight: bold;
        }
      }

      .desc, .actions {
        opacity: 0;
        transform: translateY(50%);
        transition: all .8s ease-out;
      }

      .actions {
        transition-delay: .4s;
      }
    }
    .img {
      flex: 1;
      display: none;
      opacity: 0;
      transition: opacity .8s ease-out;

      img {
        width: 100%;
        /* max-width: 758px; */
        display: block;
      }
    }
  }

  .functions {
    margin-top: 30px;
    
    ul {
      display: flex;
      flex-wrap: wrap;
      position: relative;

      .blank1, .blank2 {
        position: absolute;
        left: 0;
        top: 100px;
      }

      .blank2 {
        top: 460px;
      }
    }

    li {
      display: flex;
      flex-direction: column;
      width: calc((100% - 60px) / 3);
      margin-right: 30px;
      margin-bottom: 30px;
      padding: 50px 40px;
      box-sizing: border-box;
      border-radius: 10px 10px 10px 10px;
      text-align: center;
      transform: scale(0);
      transform-origin: center bottom;
      transition: all .6s ease-out;
      opacity: 0;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        background-color: #fff;
        box-shadow: 0px 4px 30px 0px rgba(0,0,0,0.1);
      }

      .img {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 70px;

        img {
          display: block;
        }
      }

      .name {
        margin-top: 30px;
        font-weight: bold;
        font-size: 20px;
      }

      .desc {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        line-height: 22px;
      }
    }

    &.show1 {
      li {
        &:nth-of-type(-n+3) {
          opacity: 1;
          transform: none;
        }

        &:nth-of-type(2) {
          transition-delay: 0.4s;
        }
        &:nth-of-type(3) {
          transition-delay: 0.8s;
        }
      }
    }

    &.showEnd1 {
      li {
        &:nth-of-type(-n+3) {
          transition-delay: 0s!important;
        }
      }
    }

    &.show2 {
      li {
        opacity: 1;
        transform: none;

        &:nth-of-type(5) {
          transition-delay: 0.4s;
        }
        &:nth-of-type(6) {
          transition-delay: 0.8s;
        }
      }
    }

    &.showEnd2 {
      li {
        transition-delay: 0s!important;
      }
    }
  }  
`

export const Ecosystem = styled.div`
  padding-top: 105px;

  &.mobile {
    padding: 84px 12px 0;

    .breadcrumbs {
      margin-top: 0;
    }

    .title {
      margin-top: 18px;

      .search {
        width: 100%;
        height: 38px;
        padding: 0 12px;

        svg {
          transform: scale(0.8);
          transform-origin: left center;
        }

        input {
          margin-left: 5px;
          font-size: 13px;
        }
      }
    }

    .content {
      .types {
        padding: 0 0 15px;
        margin-top: 25px;
        margin-bottom: 10px;
      }

      .app-list {
        margin-top: 0;
        padding:  0;
      }

      li {
        width: 100%;
        padding: 0;
        margin-bottom: 20px;
        margin-right: 0;

        &:hover {
          transform: none;
        }

        &:hover, &.on {
          background-color: #fff;
        }
      }

      .desc {
        margin-top: 15px;
        padding-top: 12px;
        border-top: 1px solid #eee;
      }
    }
  }

  .title {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
      line-height: 1;
      font-size: 42px;
    }

    strong {
      color: #BF2E20;
    }

    .search {
      width: 432px;
      height: 45px;
      display: flex;
      align-items: center;
      padding: 0 15px;
      border: 1px solid #eee;
      border-radius: 5px;
      background: #F5F5F5;
      box-sizing: border-box;

      input {
        border: none;
        background-color: transparent;
        flex: 1;
        margin-left: 12px;
        font-size: 14px;
        color: #666;
        font-size: 15px;
      }
    }
  }

  .content {
    flex: 1;
    box-sizing: border-box;

    &.subscribed-root {
      padding: 0 15px;
      overflow-y: auto;
    }

    &.subcenter-root {
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;
    }

    /* &.mobile {
      padding: 20px 0;

      &.subscribed-root {
        padding: 20px 15px;
      }

      .types {
        padding-bottom: 15px;
        margin-bottom: 10px;
      }

      li {
        width: 100%;
        padding: 0;
        margin-bottom: 15px;
        margin-right: 0;

        &:hover {
          transform: none;
        }

        &:hover, &.on {
          background-color: #fff;
        }
      }

      .desc {
        margin-top: 15px;
        padding-top: 12px;
        border-top: 1px solid #eee;
      }

      .project {
        .ava {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }

        .name {
          h1 {
            margin-bottom: 5px;
          }

          p {
            font-size: 12px;
          }
        }

        .actions {
          a {
            height: 28px;
            padding: 0 12px;
            font-size: 13px;

            strong, &:hover strong {
              &:first-of-type {
                display: none!important;;
              }

              &:last-of-type {
                display: inline!important;
              }
            }
          }
          
          .red-btn {
            & > span {
              margin-right: 5px;
            }
          }
        }
      }
    } */

    .types {
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-top: 35px;
      padding: 0 0 10px;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        background: #F6F6F6;
        border-radius: 5px;
        color: #999;
        cursor: pointer;

        &:hover {
          background: #EDEDED;
        }

        &.tprev {
          margin-right: 20px;

          svg {
            transform: rotate(180deg);
          }
        }

        &.tnext {
          margin-left: 20px;
        }
      }

      .types-list {
        flex: 1;
        overflow: hidden;

        div {
          display: flex;
          flex-wrap: nowrap;
          transition: transform .3s ease-out 0s;
        }
      }

      span {
        margin-right: 10px;
        padding: 0 20px;
        line-height: 30px;
        border-radius: 14px;
        color: #999;
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }

        &.on, &:hover {
          color: #333;
          background-color: #EDEDED;
        }
      }
    }

    .app-list {
      flex: 1;
      overflow-y: auto;
      padding: 0 15px;
      margin-top: 20px;

      .info {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 10px;
    }

    .actions {
      a {
        background: transparent;
        border: 1px solid #333333;
        color: #333;
        transition: box-shadow 0.5s ease;
        padding: 0 15px;
        line-height: 35px;
        border-radius: 10px;
        font-size: 14px;
        cursor: pointer;
        text-align: center;
        box-sizing: border-box;

        &:hover {
          background: #51ADB9;
          border-color: #51ADB9;
          color: #fff;
        }
      }
    }

    li {
      display: flex;
      width: calc((100% - 10px) / 2);
      margin-bottom: 5px;
      margin-right: 10px;
      padding: 15px;
      box-sizing: border-box;
      border-radius: 10px;
      cursor: pointer;
      transition: transform 0.4s ease 0s;

      &:nth-child(2n+2) {
        margin-right: 0;
      }

      @media (min-width: 1780px) {
        width: calc((100% - 20px) / 3);

        &:nth-child(2n+2) {
          margin-right: 10px;
        }

        &:nth-child(3n+3) {
          margin-right: 0;
        }
      }

      &:hover {
        transform: scale(1.02);
      }

      &:hover, &.on {
        background-color: #EDEDED;

        .project {
          border-bottom-color: #F8F9FB;

          .actions {
            .gray-btn {
              background-color: #fff;
            }
          }
        }
      }
    }

    .ava {
      width: 50px;
      height: 50px;
      padding: 0;
      border-radius: 10px;
      border: 1px solid #EEEEEE;
      margin-right: 15px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }

      &.default-ava {
        img {
          border-radius: 0;
        }
      }
    }

    .project {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      height: 52px;

      .flex {
        display: flex;
        align-items: center;
      }

      .actions {
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 98px;
          height: 32px;
          font-size: 14px;
          border-radius: 5px;

          strong {
            font-weight: normal;
          }

          &:hover {
            strong {
              &:first-of-type {
                display: none;
              }

              &:last-of-type {
                display: inline!important;
              }
            }
          }

          & > span {
            margin-right: 6px;
          }

          & > svg {
            width: 14px;
            margin-right: 5px;
          }
        }

        .gray-btn {
          background-color: #fff;
          border: 1px solid #999;
          color: #999;
          box-shadow: none;

          &:hover {
            box-shadow: none;
          }
        }

        .num {
          margin-top: 5px;
          font-size: 12px;
          color: #999;
          text-align: center;

          span {
            color: #FF563F;
            margin-right: 6px;
          }
        }
      }

      .name {
        h1 {
          line-height: 1;
          font-size: 16px;
          margin-bottom: 10px;

          svg {
            vertical-align: middle;
            margin-left: 6px;
          }
        }

        p {
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          span {
            margin-top: 5px;
            margin-right: 5px;
            background: #F4F4F4;
            line-height: 22px;
            border-radius: 11px;
            padding: 0 8px;
            color: #999;
            font-size: 12px;
          }
        }
      }
    }

    .desc {
      margin-top: 20px;

      h2 {
        font-size: 14px;
      }

      div {
        color: #999;
        margin-top: 5px;
        min-height: 28px;
        line-height: 16px;
        font-size: 12px;
      }
    }
  }

`